export var layout = {
    sidebarWidth: 304,
    articleContentWidth: 776,
    landingContentWidth: 1024,
    headerFullWidth: 1440,
    homePageContentWidth: 1216,
    headerHeight: 64,
    mobileMarginX: 3,
};
